import { useRef } from 'react';
import { HOME_HERO, HOME_HERO_DECK, HOME_HERO_DECK_CTA } from '../../../data/site';
import { useHeroTwoScroll } from '../../../hooks/useHeroTwoScroll';
import '../../../styles/home-hero-two.css';

export function HeroSectionTwo() {
  const sectionRef = useRef<HTMLElement>(null);
  useHeroTwoScroll(sectionRef);

  return (
    <section ref={sectionRef} className="hero-two hero-two--scroll">
      <div className="hero-two__intro">
        <div className="hero-two__glow" aria-hidden />
        <div className="container hero-two__head-wrap">
          <header className="hero-two__head">
            <h1 className="hero-two__title">{HOME_HERO.title}</h1>
            <p className="hero-two__subtitle">{HOME_HERO.subtitle}</p>
          </header>
        </div>
      </div>

      <div className="hero-two__deck-stage">
        <div className="hero-two__deck-pin">
          <div className="hero-two__floor">
            <div className="hero-two__floor-plane" aria-hidden />
            <div className="hero-two__deck" aria-label="Build, grow, manage, pay, and save with Hello Gwiji">
              {HOME_HERO_DECK.map((card, index) => (
                <figure
                  key={card.slug}
                  className={`hero-two__deck-card hero-two__deck-card--${index + 1}`}
                >
                  <div className="hero-two__deck-card-face">
                    <img
                      src={card.image}
                      alt={card.alt}
                      className="hero-two__deck-image"
                      loading={index === 2 ? 'eager' : 'lazy'}
                      decoding="async"
                    />
                  </div>
                  <figcaption className="hero-two__deck-caption">{card.title}</figcaption>
                </figure>
              ))}

              <div className="hero-two__deck-cta">
                <p className="hero-two__deck-cta-title">{HOME_HERO_DECK_CTA.title}</p>
                <p className="hero-two__deck-cta-text">{HOME_HERO_DECK_CTA.text}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="hero-two__scroll-spacer" aria-hidden />
      </div>
    </section>
  );
}
